import React from "react";
import useToggle from "../../../hooks/useToggle";
import GoToTop from "../../Helpers/GoToTop";
import AddLevel from "../../Helpers/Modals/AddLevel";
import Drawer from "../../Mobile/Drawer";
import FooterOne from "../../Partials/Footers/FooterOne";
import HeaderOne from "../../Partials/Headers/HeaderOne";
import MainContent from "../OpenForBids/MainContent";

function AddStats() {
  const [drawer, setDrawer] = useToggle(false);
  const [value, setValue] = useToggle(true);
  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />
      <HeaderOne className="shop-page-header" action={setDrawer.toggle} />
      <MainContent modalAction={setValue.toggle}>
        <AddLevel action={setValue.toggle} value={value} />
      </MainContent>
      <FooterOne />
      <GoToTop />
    </>
  );
}

export default AddStats;
